import React from "react"

import { withSearchResults } from "./withSearchResults"
import { SearchPagination } from "../Pagination/SearchPagination"
import { SearchListError } from "../List/SearchListError"
import { Results } from "@usereactify/search"
import { Loading } from "../List/Loading/Loading"
import { Empty } from "../List/Empty/Empty"
import { Grid, SearchResultsWrapper } from "./SearchResultsStyles"
import { SearchResultsCard } from "./SearchResultsCard"
import { Callout } from "../../Callout/Callout"
import { useLivePrices } from "../../../hooks/useLivePrices"

export const SearchResults = withSearchResults(
  ({ collection, gridView }): JSX.Element => {
    const { prices } = useLivePrices()

    return (
      <SearchResultsWrapper gridView={gridView}>
        <Results
          includeFields={["*"]}
          listClassName="search-results"
          renderPaginationNumbered={props => <SearchPagination {...props} />}
          renderResultCardProduct={({ product }) => <SearchResultsCard item={product} collection={collection} prices={prices} />}
          renderResultCardCallout={props => <Callout gridView={gridView} {...props} />}
          renderLoading={() => (
            <Grid>
              <Loading size={12} notEmpty={true} />
            </Grid>
          )}
          renderNoResults={() => <Empty isCollection={collection?.handle} />}
          renderError={error => <SearchListError error={error} />}
        />
      </SearchResultsWrapper>
    )
  }
)
